import React, { useEffect, useState } from 'react'
import INFTCollectionCard from './INFTCollectionCard'
import { NFTCard } from '../../../components/NFTCard'
import { getSaleToken } from '../../../utils/NFTFormatedData'
import NFTSellModal from '../../../components/NFTSellModal'
import NFTTransferModal from '../../../components/NFTTransferModal'
import { getTokenSale } from '../../../../../services/NFTMarketPlace/Graphquery'
import INFTSalesList from '../../../models/INFTSalesList'
import NFTRemoveModal from '../../../components/NFTRemoveModal'
import { useApproveCallback } from '../../../../../hooks/useApproveCallback'
import { ChainId, JSBI, TokenAmount } from '@yetiswap/sdk'
import { MARKET_PLACE_ADDRESS, YTS, BOBA, ZERO_ADDRESS } from '../../../../../constants'
import { useAddPopup } from '../../../../../state/application/hooks'
import { useBuyNFTToken, useBuyNFTTokenWithAvax } from '../../../../../hooks/useNFTMarketPlace'
import { NFTBuyCallBackHandle } from '../../../utils/NFTErrorHandleHelper'
import { useActiveWeb3React } from '../../../../../hooks'

export default function NFTCollectionCard(props: INFTCollectionCard) {
  const { chainId } = useActiveWeb3React()
  const [removeModalIsOpen, setRemoveModalIsOpen] = useState(false)
  const saleToken = getSaleToken(undefined, undefined)
  const [saleModalIsOpen, setSaleModalIsOpen] = useState(false)
  const [transferModalIsOpen, setTransferModalIsOpen] = useState(false)
  const [nftName, setNFTName] = useState('')
  const [saleNFT, setSaleNFT] = useState<INFTSalesList | null>(null)
  const {
    contractAddress,
    account,
    tokenId,
    yetiswapMarketCommissionRateYTS,
    yetiswapMarketCommissionRateNonYTS,
    owner,
    priceInfo
  } = props
  const yts = chainId !== undefined ? YTS[chainId] : YTS[ChainId.BOBA]
  const boba = chainId !== undefined ? BOBA[chainId] : BOBA[ChainId.BOBA]

  useEffect(() => {
    getTokenSale(contractAddress, tokenId).then(res => setSaleNFT(res))
  }, [contractAddress])

  function showSetSaleModal(nftName: string) {
    setNFTName(nftName)
    setSaleModalIsOpen(true)
  }
  function showTransferModel(nftName: string) {
    setNFTName(nftName)
    setTransferModalIsOpen(true)
  }
  function cancelSaleModal() {
    setSaleModalIsOpen(false)
  }
  function cancelTransferModal() {
    setTransferModalIsOpen(false)
  }

  const tokenSaleIndex = saleNFT && saleNFT.saleIndex ? saleNFT.saleIndex : 0
  const tokenPrice = saleNFT && saleNFT.price ? saleNFT.price : 0
  const [approveState, approveACallback] = useApproveCallback(
    new TokenAmount(saleNFT?.saleToken === yts.address? yts : boba, JSBI.BigInt(tokenPrice)),
    chainId ? MARKET_PLACE_ADDRESS[chainId] : undefined
  )

  const addPopup = useAddPopup()
  const { buyNFTCallback } = useBuyNFTToken(tokenSaleIndex)
  const { buyNFTCallbackAvax } = useBuyNFTTokenWithAvax(tokenSaleIndex, JSBI.BigInt(tokenPrice).toString())
  function showRemoveModal(nftName: string) {
    setNFTName(nftName)
    setRemoveModalIsOpen(true)
  }
  function cancelRemoveModal() {
    setRemoveModalIsOpen(false)
  }
  function getSalesNFTItems() {
    setSaleNFT(null)
  }

  function buyNFT() {
    if (saleNFT && saleNFT.saleToken !== ZERO_ADDRESS) {
      if (buyNFTCallback) {
        buyNFTCallback()
          .then(r => {
            setTimeout(getSalesNFTItems, 2000)
          })
          .catch((e: any) => {
            console.log(e)
            const result = NFTBuyCallBackHandle(e, false)
            addPopup(result, '')
          })
      }
    } else {
      if (buyNFTCallbackAvax) {
        buyNFTCallbackAvax()
          .then(r => {
            setTimeout(getSalesNFTItems, 2000)
          })
          .catch((e: any) => {
            console.log(e)
            const result = NFTBuyCallBackHandle(e, false)
            addPopup(result, '')
          })
      }
    }
  }

  function approveNFT() {
    approveACallback()
  }

  return (
    <>
      <NFTCard
        token={saleNFT ? saleNFT : undefined}
        tokenId={tokenId}
        buyNow={buyNFT}
        approve={approveNFT}
        tokenContractAddress={contractAddress}
        setSale={showSetSaleModal}
        transferNFT={showTransferModel}
        removeSale={saleNFT ? (nftName: string) => showRemoveModal(nftName) : undefined}
        isWallet={!saleNFT}
        isSale={!!saleNFT}
        noButtons={props.noButtons}
        owner={owner}
        saleToken={saleNFT && saleNFT.saleToken ? saleNFT.saleToken : saleToken}
        approveState={approveState}
        priceInfo={priceInfo}
      />
      <NFTSellModal
        isOpen={saleModalIsOpen}
        onDismiss={() => cancelSaleModal()}
        NFTName={nftName}
        tokenId={tokenId}
        tokenContractAddress={contractAddress}
        getSalesNFTItems={getSalesNFTItems}
        yetiswapMarketCommissionRateYTS={yetiswapMarketCommissionRateYTS}
        yetiswapMarketCommissionRateNonYTS={yetiswapMarketCommissionRateNonYTS}
        //account={account}
        priceInfo={priceInfo}
      />
      <NFTTransferModal
        NFTName={nftName}
        isOpen={transferModalIsOpen}
        onDismiss={() => cancelTransferModal()}
        tokenId={tokenId}
        getSalesNFTItems={getSalesNFTItems}
        tokenContractAddress={contractAddress}
      />
      {saleNFT && (
        <NFTRemoveModal
          isOpen={removeModalIsOpen}
          onDismiss={cancelRemoveModal}
          tokenId={saleNFT && saleNFT.saleIndex ? saleNFT.saleIndex : 0}
          NFTName={nftName}
          getSalesNFTItems={getSalesNFTItems}
          key={`${saleNFT.id}_${saleNFT.tokenContract}_MODAL`}
        />
      )}
    </>
  )
}
